// The routes of a workspace's datasets, mounted by the Documents section under
// its own (`/<slug>/documents/datasets[/<id>|/new]`): Datasets go with the
// documents and have no section of their own.
import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazyScreen } from "@trameria/ui-core";

// Loaded when first opened.
const WsDatasets = lazyScreen(() => import("./screens"), "WsDatasets");
const WsDataset = lazyScreen(() => import("./screens"), "WsDataset");
const NewWsDataset = lazyScreen(() => import("./screens"), "NewWsDataset");

export function workspaceDatasetsRoutes(parent: AnyRoute): AnyRoute[] {
  const datasets = createRoute({
    getParentRoute: () => parent,
    path: "documents/datasets",
    component: WsDatasets,
  });
  // Nothing open: the list alone fills the panel.
  const list = createRoute({
    getParentRoute: () => datasets,
    path: "/",
    component: () => null,
  });
  const create = createRoute({
    getParentRoute: () => datasets,
    path: "new",
    component: NewWsDataset,
  });
  const open = createRoute({
    getParentRoute: () => datasets,
    path: "$datasetId",
    component: WsDataset,
  });
  return [datasets.addChildren([list, create, open])];
}
